import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

import { TranslateModule } from '@ngx-translate/core';

import { TableComponent } from './table.component';
import { SharedDirectivesModule } from '../../shared-directives.module';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,

    NzSpinModule,
    NzInputModule,
    NzTableModule,
    NzToolTipModule,

    TranslateModule,
    SharedDirectivesModule,
  ],
  declarations: [TableComponent],
  exports: [TableComponent],
})
export class TableModule {}
